import { render, staticRenderFns } from "./PageHeaderSearchForm.vue?vue&type=template&id=19347d2b&"
import script from "./PageHeaderSearchForm.vue?vue&type=script&lang=js&"
export * from "./PageHeaderSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports